module.exports = __webpack_public_path__ + "rec_hall-cf4aca6e40b43e7a943963cfccfa9d26.png";